import Link from 'next/link';
import CustomImage from 'components/CustomImage';
import { CustomImageProps } from 'components/CustomImage/CustomImage';

type Props = {
  href: string;
  alt: string;
  src: string;
  component?: 'menuSection' | 'menuSandboxSection';
};

const BannersImage = ({ component = 'menuSection', href, alt, src }: Props) => {
  const props: CustomImageProps = {
    alt,
    src,
    width: component === 'menuSection' ? 281 : 288,
    height: component === 'menuSection' ? 127 : 400,
    sx: {
      objectFit: 'contain',
      ...(component === 'menuSandboxSection' ? { maxHeight: 676 } : {}),
    },
  };

  return (
    <Link passHref href={href}>
      <CustomImage alt={alt} src={src} {...props} />
    </Link>
  );
};

export default BannersImage;
